<app-page
  [config]="pageConfig$ | async"
  [content]="content"
  [action]="(displayActionButtons$ | async) ? action : null"
/>

<ng-template #content>
  <app-learnosity-player playerClass="shapes-and-color" />
</ng-template>

<ng-template #action>
  @if (testletActionButtonsConfig$ | async; as config) {
    <app-testlet-action-buttons
      [config]="config"
      (buttonClicked)="handleButtonClicked($event)"
    />
  }
</ng-template>
